import {defer as observableDefer,  Observable } from 'rxjs';
import {take, refCount, publishReplay} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { ApiService } from './api';

@Injectable({ providedIn: 'root' })
export class TemplateService {

    path: string = '/ws/ua/briefings';
    private cachedAllUnauth: any;

    constructor(private api: ApiService){}

    getAllUnauth = (params?):Observable<any> => {
        if (!this.cachedAllUnauth) {
            this.cachedAllUnauth = observableDefer(() => this.api.get('/ws/ua/templates', this.api.paramify(params)))
            .pipe(
                publishReplay(1, 60000),
                refCount(),
                take(1)
            );
        }

        return this.cachedAllUnauth;
    }
}
